export enum EnumPriceCalculationType {
  Fijo = 1,
  Simple = 2,
  Complejo = 3,
  Margen = 4,
  PendienteYMargen = 5
}
